export const NoteStatusReasons = {
  closed: 'CLOSED_CASE_CLOSED',
  cancelled: 'CLOSED_CASE_CANCELLED'
};
